import * as React from 'react';
import Page from '../../Page';

interface Props {
	value: string;
	immediate?: boolean;
	color?: string;
}

interface State {
}

export default class MathBoxComponent extends React.Component<Props, State> {

	componentDidMount () {
		Page.requestTypesetting(this.props.immediate !== undefined ? this.props.immediate : false);
	}

	componentDidUpdate () {
		Page.requestTypesetting(this.props.immediate !== undefined ? this.props.immediate : false);
	}

	render () {
		return <span style={{color: this.props.color !== undefined ? this.props.color : '#0099FF'}}>{'\\[' + this.props.value + '\\]'}</span>;
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/shared/MathBoxComponent.tsx